/**
 * Placeholder mientras se resuelve el perfil del usuario: evita pintar una
 * vista y reemplazarla por la otra.
 */
export default function SeleccionCuentaSkeleton() {
  return (
    <div className="mt-[20px] mx-[40px] lg:mx-[96px] pb-8" aria-busy="true" aria-label="Cargando selección de cuenta">
      <div className="mb-2 h-6 w-48 animate-pulse rounded bg-gray-300" />
      <div className="h-4 w-80 max-w-full animate-pulse rounded bg-gray-300" />
      <div className="mt-6 h-64 w-full animate-pulse rounded bg-gray-200" />
    </div>
  )
}
